﻿import $ from 'jquery';
import 'moment';
import { Patches } from './patches';
import { Polyfills } from './polyfills';

import { ActionResult } from './utilities/actionresult';

import { AddressLoader } from './modules/addressloader';
import { AgeField } from './modules/agefield';
import { AsyncFileField } from './modules/asyncfilefield';
import { BrowserHistory } from './modules/browserhistory';
import { DateField } from './modules/datefield';
import { DateRangeField } from './modules/daterangefield';
import { Drawer } from './modules/drawer';
import { DualListBox } from './modules/duallistbox';
import { EditorTable } from './modules/editortable/editortable';
import { FileDragOut } from './modules/filedragout';
import { FileInput } from './modules/fileinput';
import { FilterItems } from './modules/filteritems';
import { ItemList } from './modules/itemlist';
import { JsonBuilder } from './modules/editortable/jsonbuilder';
import { Modal } from './modules/modal';
import './modules/multiselectcontextmenuitem';
import { MultiSelectDropdown } from './modules/multiselectdropdown';
import { MultiSelectTable } from './modules/multiselecttable';
import { PhotoViewer } from './modules/photoviewer';
import { PopOver } from './modules/popover';
import { RealTimeValidation } from './modules/realtimevalidation';
import { Remote } from './modules/remote/remote';
import { RemotePopOver } from './modules/remotepopover';
import { RichText } from './modules/richtext';
import { SearchField } from './modules/searchfield';
import { SuggestSearch } from './modules/suggestsearch';
import { Tabs } from './modules/tabs';
import { ThumbnailDownloader } from './modules/thumbnaildownloader';
import { ThumbnailUpload } from './modules/thumbnailupload';
import { ToggleState } from './modules/togglestate';
import { TreeInput } from './modules/treefield/treeinput';
import { Validation } from './modules/editortable/validation';

import { AutoHeightTable } from './utilities/autoheighttable';
import { AutoRequest } from './utilities/autorequest';
import { Autosave } from './utilities/autosave';
import { CheckboxValidationHandler } from './utilities/formvalidation/checkboxvalidationhandler';
import { DateExpression } from './utilities/dateexpression';
import { DocumentViewer } from './utilities/documentviewer';
import { ErrorPopover } from './utilities/formvalidation/errorpopover';
import { EventListener } from './utilities/eventlistener';
import { EventNotifier } from './utilities/eventnotifier';
import { FieldValidationHandler } from './utilities/formvalidation/fieldvalidationhandler';
import { FormValidation } from './utilities/formvalidation/formvalidation';
import { HandlesWindowNavigation } from './utilities/handleswindownavigation';
import { HasChanges } from './utilities/haschanges';
import { KeyboardScrollable } from './utilities/keyboardscrollable';
import { MathExpressions } from './utilities/mathexpressions';
import { MultiSelectDropdownValidationHandler } from './utilities/formvalidation/multiselectdropdownvalidationhandler';
import { NameValidationHandler } from './utilities/formvalidation/namevalidationhandler'
import { Navigate } from './utilities/navigate';
import { PersonName } from './utilities/personname';
import { PhoneValidationHandler } from './utilities/formvalidation/phonevalidationhandler';
import { PrintPreview } from './utilities/printpreview';
import { RadioValidationHandler } from './utilities/formvalidation/radiovalidationhandler';
import { ReadonlyIf } from './utilities/readonlyif';
import { ScrollTo } from './utilities/scrollto';
import { ShowIf } from './utilities/showif';
import { ToggleValue } from './utilities/togglevalue';
import { TransformTextToLink } from './utilities/transformtexttolink';
import { ValueBinding } from './utilities/valuebinding';
import './utilities/visibility';

import Application from './application';
import KeyboardFocusBounds from './utilities/keyboardfocusbounds';
import DragAndDropUpload from './modules/draganddropupload';
import { DropdownValidationHandler } from './utilities/formvalidation/dropdownvalidationhandler';
import { DateRangeValidationHandler } from './utilities/formvalidation/daterangevalidationhandler';
import { AsyncFileValidationHandler } from './utilities/formvalidation/asyncfilevalidationhandler';
import { ElementPosition } from './utilities/elementposition';

export class Wireup {

  constructor() {
    this.registerDefaults();
  }

  push(selector, wireup) {
    Application.convention(selector, wireup);
  }

  execute() {

    console.log('rustig initializing');

    Polyfills.Execute();
    Patches.Execute();

    window.Rustig = {
      ActionResult: ActionResult,
      Modal: Modal,
      PersonName: PersonName,
      ThumbnailDownloader: ThumbnailDownloader,
      AddressLoader: AddressLoader,
      AsyncFileField: AsyncFileField,
      ElementPosition: ElementPosition
    };
    //hack for editortable, fix this
    window.JsonBuilder = JsonBuilder;
    window.isWindowUnloading = false;
    window.onbeforeunload = function () {
      window.isWindowUnloading = true;
    };
    Application.conventionsReady = false;

    let defaults = {};
    window.RUSTIG_OPTIONS = $.extend({}, defaults, window.RUSTIG_OPTIONS);
    window.Application = Application;

    Application.wireupConventions(document);
    Application.triggerConventionsReady();

  }

  private registerDefaults() {
    // Don't click the first button in a form when hitting the enter key
    $(document).on('keypress.rustig', 'form:not([data-allow-enter]) input[type!=submit], form:not([data-allow-enter]) select', function (event) {
      return event.keyCode != 13;
    });

    $(document).on('formvalidationhandled.rustig.formvalidation', Tabs.applyErrors);

    FormValidation.registerHandler(
      new PhoneValidationHandler(),
      new NameValidationHandler(),
      new RadioValidationHandler(),
      new CheckboxValidationHandler(),
      new DropdownValidationHandler(),
      new DateRangeValidationHandler(),
      new AsyncFileValidationHandler(),
      new FieldValidationHandler(),
      new MultiSelectDropdownValidationHandler()
    );


    Application.convention('[disabled]', $.fn.disable);
    Application.convention('.name-field', $.fn.nameField);
    Application.convention('.phone-field', $.fn.phoneField);
    Application.convention('.money-field', $.fn.moneyField);
    Application.convention('.number-field', $.fn.numberField);
    Application.convention('.percent-field', $.fn.percentField);
    Application.convention('select:not("[data-et-vanilla-select]")', $.fn.dropDown);
    Application.convention(SearchField.wireup, $.fn.searchField);
    Application.convention(RichText.wireup, $.fn.richtext);
    Application.convention('[data-error-message]', $.fn.errorMessage);
    Application.convention(PopOver.wireup, $.fn.popover);
    Application.convention(RemotePopOver.wireup, $.fn.remotePopover);
    Application.convention(Tabs.wireup, $.fn.tabs);
    Application.convention('[data-nav]', $.fn.nav);
    Application.convention(DateField.wireup, $.fn.datefield);
    Application.convention(MultiSelectTable.wireup, $.fn.multiselecttable);
    Application.convention(EditorTable.wireup, $.fn.editortable);
    Application.convention(FileInput.wireup, $.fn.fileinput);
    Application.convention(FileDragOut.wireup, $.fn.filedragout);
    Application.convention(Remote.triggerWireup, Remote.wireupTriggers);
    Application.convention(ValueBinding.wireup, $.fn.valuebinding);
    Application.convention(Validation.wireup, $.fn.editortable_validation);
    Application.convention('.field-validation-error', () => FormValidation.handleErrors());
    Application.convention(DocumentViewer.wireup, $.fn.documentviewer);
    Application.convention(ThumbnailUpload.wireup, $.fn.thumbnailupload);
    Application.convention(SuggestSearch.wireup, $.fn.suggestsearch);
    Application.convention(ToggleState.wireup, $.fn.togglestate);
    Application.convention(Drawer.wireup, $.fn.drawer);
    Application.convention(KeyboardScrollable.wireup, $.fn.keyboardscrollable);
    Application.convention(BrowserHistory.wireup, BrowserHistory.createHistory);
    Application.convention(Navigate.wireup, $.fn.navigate);
    Application.convention(PhotoViewer.wireup, $.fn.photoviewer);
    Application.convention(RealTimeValidation.wireup, $.fn.realtimevalidation);
    Application.convention(EventListener.wireup, $.fn.eventlistener);
    Application.convention(EventNotifier.wireup, $.fn.eventnotifier);
    Application.convention(Autosave.wireup, $.fn.autosave);
    Application.convention(TransformTextToLink.wireup, $.fn.transformtexttolink);
    Application.convention(ThumbnailDownloader.wireup, $.fn.thumbnaildownloader);
    Application.convention(TreeInput.wireup, $.fn.treeinput);
    Application.convention('.dropdowntree-field', $.fn.dropdowntree);
    Application.convention(AutoRequest.wireup, $.fn.autorequest);
    Application.convention(AsyncFileField.wireup, $.fn.asyncfilefield);
    Application.convention('[data-multiselect-checkbox]:not([data-multiselect-selector])', $.fn.multiselecttablerow);
    Application.convention(ScrollTo.wireup, $.fn.scrollto);
    Application.convention(FilterItems.wireup, $.fn.filteritems);
    Application.convention(MultiSelectDropdown.wireup, $.fn.multiselectdropdown);
    Application.convention(DateRangeField.wireup, function () {
      $(this).each(function () {
        DateRangeField.load(this);
      });
    });
    Application.convention(DragAndDropUpload.wireup, function () {
      $(this).each(function () {
        DragAndDropUpload.load(this);
      });
    });
    Application.convention(DateExpression.wireup, $.fn.dateexpression);
    Application.convention(DualListBox.wireup, $.fn.duallistbox);
    Application.convention(AutoHeightTable.wireup, $.fn.autoheighttable);

    AgeField.wireupDocument();
    AddressLoader.wireupDocument();
    ItemList.wireupDocument();
    Remote.wireupDocument();
    Modal.initialize();
    ToggleValue.wireupDocument();
    ReadonlyIf.wireupDocument();
    ShowIf.wireupDocument();
    KeyboardFocusBounds.wireupDocument();
    DragAndDropUpload.wireupDocument();
    MathExpressions.wireup();
    PrintPreview.wireup();
    HasChanges.wireup();
  }
}
